import './Step.scss';
import classnames from 'classnames';

const Step = ({ onClick, step }) => {
  const handleKeyUp = (e) => {
    e.key === 'Enter' && onClick(e);
  };

  const containerStyles = classnames('step-container v-stepper', {
    'is-active is-complete': step.status === 'activecomplete',
    'is-active is-error': step.status === 'activeerror',
    'is-complete': step.status === 'complete' && step.touched === true,
    'is-error': step.status === 'error' && step.touched === true,
    'sub-step': step.isSubStep,
    touched: step.touched === true,
    hidden: step.hidden === true,
  });

  return (
    <div
      className={containerStyles}
      data-stepid={step.id}
      onClick={onClick}
      onKeyUp={handleKeyUp}
      tabIndex={step.hidden === false ? 0 : -1}
    >
      <div className='step-line'>
        <div />
      </div>
      <div className='step-icon' role='alert' />
      <div className='step-label'>{step.label}</div>
    </div>
  );
};

export default Step;
